export enum BusinessCaseCalculationType {
  Absolute = 1 << 0,
  Relative = 1 << 1,
}

export const BusinessCaseCalculationTypeLabels: { [key: number]: string } = {
  [BusinessCaseCalculationType.Absolute]: "Absolut",
  [BusinessCaseCalculationType.Relative]: "Relativ",
}
